import React from "react";
import NoResultsFound from "./NoResultsFound";

interface Props {
  height: number;
  columnCount: number;
}

const NoResultsTableRow: React.FC<Props> = ({ height, columnCount }) => {
  return (
    <tbody>
      <tr>
        <td colSpan={columnCount}>
          <div style={{ height: height }} className="flex items-center h-48 justify-center w-full">
            <NoResultsFound />
          </div>
        </td>
      </tr>
    </tbody>
  );
};

export default NoResultsTableRow;
